module.exports = __webpack_public_path__ + "img/Your_Logo_Here.ece05bb.png";